import './client.scss'
import { PlusOutlined, SearchOutlined, WhatsAppOutlined, PhoneOutlined, EnvironmentOutlined, EyeOutlined, UserOutlined, EditOutlined, DeleteOutlined, MergeCellsOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Popconfirm, Popover, Tag, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import config from '../../config';
import axios from 'axios';
import MouvClientDetail from '../mouvement/mouvementClientDetail/MouvClientDetail';
import { useSelector } from 'react-redux';
import ClientTelephone from './clientTelephone/ClientTelephone';
import Swal from 'sweetalert2';
import usePermissions from '../../hooks/usePermissions';
import { Select as AntSelect } from 'antd';
import ClientAdresse from './clientAdresse/ClientAdresse';
import ClientView from './ClientView';
import ClientForm from './clientForm/ClientForm';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeDataCard, NdoeStatusBadge, NdoeStats, NdoeStatCard,
} from '../../components/ndoe';

const Client = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [getClient, setGetClient] = useState();
    const [loading, setLoading] = useState(true);
    const searchInput = useRef(null);
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const [open, setOpen] = useState(false);
    const [opens, setOpens] = useState(false);
    const [openss, setOpenss] = useState(false);
    const [openAdresse, setOpenAdresse] = useState(false);
    const [openForm, setOpenForm] = useState(false);
    const [openDetailAdresse, setOpenDetailAdresse] = useState(false);
    const [idClient, setIdClient] = useState({});
    const user = useSelector((state) => state.user?.currentUser);
    // Fusion de fiches (20/07) : permission FINE clientes.fusionner (admin par
    // défaut, accordable par utilisatrice dans la matrice des permissions).
    const { can } = usePermissions();
    const peutFusionner = can('clientes.fusionner');
    const [fusion, setFusion] = useState(null);        // { source } puis + cible, apercu
    const [fusionBusy, setFusionBusy] = useState(false);

    const chargerApercuFusion = async (idSource, idCible) => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/client/fusion/apercu`, { params: { source: idSource, cible: idCible } });
        setFusion((f) => (f ? { ...f, cible: idCible, apercu: data } : f));
      } catch (e) {
        toast.error(e.response?.data?.error || 'Aperçu impossible.');
        setFusion((f) => (f ? { ...f, cible: idCible, apercu: null } : f));
      }
    };

    const executerFusion = async () => {
      if (!fusion?.source || !fusion?.cible || fusionBusy) return;
      const src = fusion.apercu?.source; const dst = fusion.apercu?.cible;
      const ok = await Swal.fire({
        title: 'Fusionner ces deux fiches ?',
        html: `<p style="margin:0"><b>${src?.nom || 'Source'}</b> sera absorbée par <b>${dst?.nom || 'Cible'}</b>.<br/>`
          + 'Tout l’historique (commandes, ventes, paiements, téléphones, adresses…) sera rattaché à la fiche conservée. '
          + 'La fiche absorbée disparaît des listes (jamais effacée : traçée).</p>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Fusionner',
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#b74b49',
      });
      if (!ok.isConfirmed) return;
      setFusionBusy(true);
      try {
        await axios.post(`${DOMAIN}/api/client/fusion/appliquer`, { source: fusion.source.id, cible: fusion.cible });
        toast.success('Fusion effectuée — tout l’historique est rattaché à la fiche conservée.');
        setFusion(null);
        fetchData();
      } catch (e) {
        toast.error(e.response?.data?.error || 'Fusion impossible.');
      } finally { setFusionBusy(false); }
    };


      const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
      const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
      };
      const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
          <div
            style={{
              padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{
                marginBottom: 8,
                display: 'block',
              }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Search
              </Button>
              <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Reset
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({
                    closeDropdown: false,
                  });
                  setSearchText(selectedKeys[0]);
                  setSearchedColumn(dataIndex);
                }}
              >
                Filter
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  close();
                }}
              >
                close
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined
            style={{
              color: filtered ? '#1677ff' : undefined,
            }}
          />
        ),
        onFilter: (value, record) =>
          record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });

      const showModal = (e) => {
        setOpen(true);
        setIdClient(e)
      };

      const showModalPhone = (e) => {
        setOpens(true);
        setIdClient(e)
      };

      const showModalAdresse = (e) => {
        setOpenAdresse(true);
        setIdClient(e)
      };

      const showModalDetailAdresse = (e) => {
        setOpenDetailAdresse(true);
        setIdClient(e)
      };

      const handleClick = () => {
        setOpenss(!openss)
      }

      const columns = [
        { title: '#', dataIndex: 'id', key: 'id', render: (text, record, index) => index + 1 },
        {
            title: 'Nom',
            dataIndex: 'nom',
            key: 'nom',
            ...getColumnSearchProps('nom'),
            render : (text,record)=>(
              <div>
                 <Tag color={'green'} onClick={()=> showModal(record.id)} style={{cursor: "pointer"}}><UserOutlined style={{ marginRight: "5px" }} />{text}</Tag>
              </div>
            )
        },
        {
            title: 'Raison sociale',
            dataIndex: 'raison_sociale',
            key: 'raison_sociale',
            ...getColumnSearchProps('raison_sociale'),
            render: (text)=> {
              return <Tag color={'green'}>{text}</Tag>;
            }
        },
          {
            title: 'Telephone',
            dataIndex: 'telephone',
            key: 'telephone',
            render: (text) => (
              <Popover content="Discutez avec lui sur WhatsApp" placement="top">
              <Tag
                onClick={() => window.open(`https://wa.me/${text}`, '_blank')}
                color="green"
                style={{ cursor: 'pointer' }}
              >
                <WhatsAppOutlined style={{ color: 'green', marginRight: '5px' }} />
                {text}
              </Tag>
            </Popover>
            ),
          },
          {
            title: 'Ville',
            dataIndex: 'nom_province',
            key: 'nom_province',
            ...getColumnSearchProps('nom_province'),
            render: (text) => (
              <div>
                <Tag color="blue">
                  <EnvironmentOutlined style={{ marginRight: '5px' }} />
                  {text}
                </Tag>
              </div>
            ),
          },
        {
            title: 'Commune',
            dataIndex: 'nom_commune',
            key: 'nom_commune',
            render : (text,record)=>(
              <div>
                <Popover content={`Ajouter une nouvelle adresse de Mme ${record.nom} `} placement="top">
                  <Tag color={'blue'} onClick={()=> showModalAdresse(record.id)}><EnvironmentOutlined style={{ marginRight: '5px' }} />{text}</Tag>
                </Popover>
              </div>
            )
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (

              <Space size="middle">
                <Popover title={`Ajouter un nouveau numero de Mme ${record.nom}`} trigger="hover">
                  <Button icon={<PhoneOutlined />} style={{ color: 'green' }} onClick={()=> showModalPhone(record.id)} />
                </Popover>
                <Popover title="Modifier" trigger="hover">
                  <Button icon={<EditOutlined />} style={{ color: 'green' }} onClick={()=> handleEdit(record.id)} />
                </Popover>
                <Popover title="Afficher les détails des adresses." trigger="hover">
                  <Button icon={<EyeOutlined />} style={{ color: 'blue', cursor: 'pointer' }} onClick={()=> showModalDetailAdresse(record.id)}/>
                </Popover>
                {peutFusionner && (
                <Popover title={`Fusionner « ${record.nom} » dans une autre fiche (doublon)`} trigger="hover">
                  <Button icon={<MergeCellsOutlined />} style={{ color: '#8a5a10' }}
                    onClick={() => setFusion({ source: { id: record.id, nom: record.nom, telephone: record.telephone } })} />
                </Popover>
                )}
                  {user?.role === 'admin' &&
                <Popover title="Supprimer" trigger="hover">
                  <Popconfirm
                    title="Êtes-vous sûr de vouloir supprimer?"
                    onConfirm={() => handleDelete(record.id)}
                    okText="Oui"
                    cancelText="Non"
                  >
                    <Button icon={<DeleteOutlined />} style={{ color: 'red' }} />
                  </Popconfirm>
                </Popover>}
              </Space>
            ),
          },
      ];

        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/client`);
            setGetClient(data);
            setLoading(false)
          } catch (error) {
            console.log(error);
            setLoading(false);
          }
        };

      useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [DOMAIN]);

      const handleEdit = (id) => {
        navigate(`/clientEdit/${id}`);
      };

      const handleDelete = async (id) => {
      try {
          await axios.put(`${DOMAIN}/api/client/clientDelete/${id}`);
          toast.success('Client supprimé');
          fetchData();   // refetch au lieu de recharger toute la page
        } catch (err) {
          toast.error("La suppression du client a échoué");
        }
      };

  // Recherche par téléphone NORMALISÉE (20/07) : « 0854… », « +243854… » et
  // « 243 854… » désignent le même numéro — on compare les chiffres seuls.
  const chiffres = (v) => String(v || '').replace(/\D/g, '');
  const qChiffres = chiffres(searchValue);
  const filteredData = getClient?.filter((item) =>
    item.nom?.toLowerCase().includes(searchValue.toLowerCase()) ||
    item.nom_province?.toLowerCase().includes(searchValue.toLowerCase()) ||
    item.nom_commune?.toLowerCase().includes(searchValue.toLowerCase()) ||
    item.telephone?.toLowerCase().includes(searchValue.toLowerCase()) ||
    (qChiffres.length >= 4 && chiffres(item.telephone).includes(qChiffres))
);

  // KPI dérivés de la liste chargée (aucun endpoint nouveau).
  const totalClients = getClient?.length || 0;
  const totalVip = getClient?.filter((c) => c.raison_sociale && String(c.raison_sociale).trim()).length || 0;

  // Carte mobile : nom, téléphone · commune, badge VIP (raison_sociale),
  // actions tél / voir / éditer / suppr (Suppr. gardé derrière user.role === 'admin').
  const renderClientCard = (record) => {
    const subtitle = [record.telephone, record.nom_commune].filter(Boolean).join(' · ');
    const isVip = record.raison_sociale && String(record.raison_sociale).trim();
    const phone = record.telephone ? String(record.telephone).replace(/[^0-9]/g, '') : null;
    const actions = [
      phone && (
        <NdoeActionButton
          key="tel"
          size="sm"
          variant="secondary"
          icon={<WhatsAppOutlined />}
          as="a"
          href={`https://wa.me/${phone}`}
          target="_blank"
          rel="noreferrer"
        >
          Tél
        </NdoeActionButton>
      ),
      <NdoeActionButton key="voir" size="sm" variant="ink" icon={<EyeOutlined />} onClick={() => showModalDetailAdresse(record.id)}>
        Voir
      </NdoeActionButton>,
      <NdoeActionButton key="edit" size="sm" variant="ghost" icon={<EditOutlined />} onClick={() => handleEdit(record.id)}>
        Éditer
      </NdoeActionButton>,
      // ⑤ parité mobile : « ajouter un numéro » / « ajouter une adresse » étaient
      // seulement atteignables via la table (colonne/tag) — on les rend accessibles
      // depuis la carte (mêmes handlers/modales existants).
      <NdoeActionButton key="num" size="sm" variant="ghost" icon={<PhoneOutlined />} onClick={() => showModalPhone(record.id)}>
        N°
      </NdoeActionButton>,
      <NdoeActionButton key="adr" size="sm" variant="ghost" icon={<EnvironmentOutlined />} onClick={() => showModalAdresse(record.id)}>
        Adresse
      </NdoeActionButton>,
      user?.role === 'admin' && (
        <Popconfirm
          key="del"
          title="Êtes-vous sûr de vouloir supprimer?"
          onConfirm={() => handleDelete(record.id)}
          okText="Oui"
          cancelText="Non"
        >
          <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />}>Suppr.</NdoeActionButton>
        </Popconfirm>
      ),
    ].filter(Boolean);

    return (
      <NdoeDataCard
        title={record.nom}
        subtitle={subtitle}
        badge={isVip ? <NdoeStatusBadge kind="custom" tone="gold" label={record.raison_sociale} /> : null}
        onClick={() => showModal(record.id)}
        actions={actions}
      />
    );
  };

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Commerce"
        title="Liste des clients"
        subtitle="Gérez vos clients"
        actions={
          <NdoeActionButton variant="primary" icon={<PlusOutlined />} onClick={handleClick}>
            Ajouter un nouveau client
          </NdoeActionButton>
        }
      />

      <NdoeStats>
        <NdoeStatCard label="Total clients" value={totalClients} />
        <NdoeStatCard label="Clients VIP" value={totalVip} />
      </NdoeStats>

      <NdoeToolbar
        search={
          <Input.Search
            type="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Rechercher (nom, ville, commune, téléphone)…"
            allowClear
            style={{width:'250px'}}
          />
        }
      />

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns}
        rowKey="id"
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 15 }}
        renderCard={renderClientCard}
        empty={{ icon: '👥', title: 'Aucun client', text: 'Ajoutez un client ou ajustez la recherche.' }}
      />

      {/* Modales */}
      <Modal
        title="Information de client"
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={850}
        footer={[]}
      >
        <MouvClientDetail idClients={idClient}/>
      </Modal>
      <Modal
        title="Ajouter un nouveau numero"
        centered
        open={opens}
        onCancel={() => setOpens(false)}
        width={600}
        footer={[]}
      >
        <ClientTelephone idClients={idClient}/>
      </Modal>
      <Modal
        title="Ajouter une nouvelle adresse"
        centered
        open={openAdresse}
        onCancel={() => setOpenAdresse(false)}
        width={800}
        footer={[]}
      >
        <ClientAdresse idClients={idClient}/>
      </Modal>
      <Modal
        title=""
        centered
        open={openDetailAdresse}
        onCancel={() => setOpenDetailAdresse(false)}
        width={1200}
        footer={[]}
      >
        <ClientView id_client={idClient}/>
      </Modal>
      <Modal
        title=""
        centered
        open={openss}
        onCancel={() => setOpenss(false)}
        width={1000}
        footer={[]}
      >
        <ClientForm fetchData={fetchData} closeModal={()=> setOpenss(!openss)} />
      </Modal>

      {/* ── Fusion de fiches clientes (permission clientes.fusionner) ────── */}
      <Modal
        title={fusion ? `Fusionner « ${fusion.source?.nom} » dans…` : ''}
        centered
        open={!!fusion}
        onCancel={() => setFusion(null)}
        width={560}
        footer={null}
        destroyOnClose
      >
        {fusion && (
          <div className="cl-fusion">
            <p style={{ color: 'var(--ndoe-muted, #5d6b80)', marginTop: 0 }}>
              La fiche <b>{fusion.source?.nom}</b>{fusion.source?.telephone ? ` (${fusion.source.telephone})` : ''} sera
              ABSORBÉE : choisissez la fiche à CONSERVER. Tout l'historique sera rattaché à la fiche conservée.
            </p>
            <AntSelect
              showSearch
              style={{ width: '100%' }}
              placeholder="Fiche à conserver (nom ou téléphone)…"
              optionFilterProp="label"
              value={fusion.cible || null}
              onChange={(v) => chargerApercuFusion(fusion.source.id, v)}
              options={(getClient || [])
                .filter((c) => c.id !== fusion.source?.id)
                .map((c) => ({ value: c.id, label: c.telephone ? `${c.nom} — ${c.telephone}` : c.nom }))}
            />
            {fusion.apercu && (
              <div style={{ marginTop: 14, fontSize: 13 }}>
                {[['Absorbée', fusion.apercu.source], ['Conservée', fusion.apercu.cible]].map(([titre, f]) => (
                  <p key={titre} style={{ margin: '6px 0' }}>
                    <b>{titre} :</b> {f.nom} — {f.volumes.commande} commande(s), {f.volumes.vente} vente(s),{' '}
                    {f.volumes.paiement} paiement(s), {f.volumes.telephone} téléphone(s), {f.volumes.adresse} adresse(s)
                  </p>
                ))}
              </div>
            )}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
              <Button onClick={() => setFusion(null)}>Annuler</Button>
              <Button type="primary" danger loading={fusionBusy} disabled={!fusion.cible || !fusion.apercu}
                onClick={executerFusion}>
                Fusionner
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </NdoePage>
  )
}

export default Client
